import { Routes, Route, Navigate } from 'react-router-dom';
import { LoginPage } from './pages/LoginPage';
import { OrderListPage } from './pages/OrderListPage';
import { GalleryPage } from './pages/GalleryPage';
import { EditorPage } from './pages/EditorPage';
import { DownloadPage } from './pages/DownloadPage';
import { PrintSelectionPage } from './pages/PrintSelectionPage';
import { AdminLoginPage } from './pages/AdminLoginPage';
import { AdminOrderListPage } from './pages/AdminOrderListPage';
import { AdminUploadPage } from './pages/AdminUploadPage';
import { AdminPrintOrdersPage } from './pages/AdminPrintOrdersPage';
import { CookiePolicyPage } from './pages/CookiePolicyPage';
import { PrivacyNoticePage } from './pages/PrivacyNoticePage';
import { NotFoundPage } from './pages/NotFoundPage';
import { ProtectedRoute } from './components/ProtectedRoute';
import { AdminRoute } from './components/AdminRoute';
import { FeatureGate } from './components/FeatureGate';
import { RootRedirect } from './components/RootRedirect';
import { Footer } from './components/Footer';
import { Header } from './components/Header';
import { PRINT_ORDERING } from './contexts/ConfigContext';

export function App() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Header />
      <div style={{ flex: '1 0 auto' }}>
        <Routes>
          <Route path="/" element={<RootRedirect />} />
          <Route path="/login" element={<LoginPage />} />

          {/* Customer routes — protected */}
          <Route path="/orders" element={<ProtectedRoute><OrderListPage /></ProtectedRoute>} />
          <Route path="/orders/:orderId" element={<ProtectedRoute><GalleryPage /></ProtectedRoute>} />
          <Route path="/orders/:orderId/download" element={<ProtectedRoute><DownloadPage /></ProtectedRoute>} />
          {/* Scan editor — the page itself redirects to the gallery when the
              scan-editing flag is off for this customer. */}
          <Route path="/orders/:orderId/edit/:scanId" element={<ProtectedRoute><EditorPage /></ProtectedRoute>} />
          {/* Print ordering — flag-gated. Auth first (so a login redirect
              preserves /print), then FeatureGate, which waits for the config
              fetch before deciding: choosing the redirect from the not-yet-
              loaded default config was what bounced hard navigations (reload,
              Back from Shopify checkout) to /orders. */}
          <Route
            path="/print"
            element={
              <ProtectedRoute>
                <FeatureGate flag={PRINT_ORDERING} fallbackTo="/orders">
                  <PrintSelectionPage />
                </FeatureGate>
              </ProtectedRoute>
            }
          />

          {/* Admin routes */}
          <Route path="/admin" element={<Navigate to="/admin/login" replace />} />
          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route path="/admin/orders" element={<AdminRoute><AdminOrderListPage /></AdminRoute>} />
          <Route path="/admin/orders/:orderId/upload" element={<AdminRoute><AdminUploadPage /></AdminRoute>} />
          <Route path="/admin/orders/:orderId/preview" element={<AdminRoute><GalleryPage preview /></AdminRoute>} />
          <Route path="/admin/print-orders" element={<AdminRoute><AdminPrintOrdersPage /></AdminRoute>} />

          {/* Public pages */}
          <Route path="/cookie-policy" element={<CookiePolicyPage />} />
          <Route path="/privacy" element={<PrivacyNoticePage />} />

          {/* Catch-all: an unmatched path used to render an empty body. */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </div>
      <Footer />
    </div>
  );
}
